<template>
  <div id="app">
    <!-- Alerts and loader -->
    <Alert />
    <Loader v-if="loader" />
    <router-view />
    <v-alert v-if="test" type="info" color="#FF8F1C" dark dense elevation="2" class="test-environment-badge">
      <span>Ambiente de pruebas</span>
    </v-alert>
  </div>
</template>

<script>
// Vuex
import { mapState } from "vuex";
// Components
import Loader from "@/components/Loader";
import Alert from "@/components/Alert";

export default {
  name: "App",

  data: () => ({
    test: false,
  }),

  components: {
    Loader,
    Alert,
  },

  computed: {
    ...mapState(["loader"]),
  },
};
</script>

<style scoped>
.test-environment-badge {
  position: fixed;
  right: 20px;
  top: 70px;
  z-index: 100;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: bold;
  opacity: 0.9;
}
</style>